var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mic-line"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 649",
    cx: 24,
    cy: 14,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 650",
    cx: 24,
    cy: 24,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 651",
    cx: 24,
    cy: 34,
    r: 4,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/moreIcon.680b04c0898fcc0f1049e170f05f6e09.svg";
export { ForwardRef as ReactComponent };